import store from '@/store/store'

class TemplateSelectorModule {

  templateSelector = () => store.state.ui.preview.templateSelector

  hideSelector() {
    store.commit('UI_TEMPLATE_SELECTOR_SET', {
      stateId: null,
      isInsideCondition: false,
      isShown: false
    })
  }

  showSelector(stateId, isInsideCondition) {
    store.commit('UI_TEMPLATE_SELECTOR_SET', {
      stateId,
      isInsideCondition,
      isShown: true
    })
  }
}

export default new TemplateSelectorModule()
